<template>
  <div class="SpritesC"
      v-if='boxData.judgeBox'
      @mouseout="judgedragFs(true)"
      @mouseover="judgedragFs(false)"
      :style="{
        'top'     : boxData.fix.y+'px',
        'left'    : boxData.fix.x+'px',
        'z-index' : boxData.Zindex,
      }"
      :class="{
        'layerSettingBox' : actionType == 'layerSetting',
        'spritesAlignBox' : actionType == 'spritesAlign',
      }"
      @mousedown="stopDocument($event);"
      @click="stopDocument($event);"
    >

    <div class="dragArea" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': (boxData.moveoks?'move':'move')}">
      <span>{{dragAreaName}}</span>
      <i class="icon-popup-close" @click="close()"></i>
    </div>

    <div class="spriteBoody" v-if='actionType == "layer"'>
      <draggable id="spritesDrag" v-model="spritesData" :options="dragOptions" :move="onMove" @end="onEnd">

      <div
        class="sprite"
        :data-id="item.id"
        :data-index="item.index"
        v-for="(item, index) in spritesData"
        :key="index"
      >
        <div
          class="thumbnails"
          v-html="item.thumbnails.prop('outerHTML')"
          @click.stop="selectSprite(item.id)"
        >
        </div>
        <div class="spritestit">
          <span v-html="spritesTit(item.type)"></span>
          <div class="spriteBtn">
            <span @click="moveSprites(true, item.id)" class="icon-layer-top-big"></span>
            <span @click="moveSprites(false, item.id)" class="icon-layer-bottom-big"></span>
          </div>
        </div>
      </div>

      </draggable>
    </div>

    <div class="spriteBoody_layerSetting" v-if='actionType == "layerSetting"'>
      <div
        @click='layerSettingFS("bottom")'
      >
        <i class="icon-editor-btn-layer-top"></i>
        <span>置顶</span>
      </div>
      <div
        @click='layerSettingFS("next")'
        :class="{
          'layerDisable' : !layersprite.top,
        }"
      >
        <i class="icon-editor-btn-layer-up"></i>
        <span>上移一步</span>
      </div>
      <div
        @click='layerSettingFS("top")'
      >
        <i class="icon-editor-btn-layer-bottom"></i>
        <span>置底</span>
      </div>
      <div
        @click='layerSettingFS("pre")'
        :class="{
          'layerDisable' : !layersprite.bottom,
        }"
      >
        <i class="icon-editor-btn-layer-down"></i>
        <span>下移一步</span>
      </div>
    </div>

    <div class="spriteBoody_spritesAlign" v-if='actionType == "spritesAlign"'>
      <div
        v-for="item in spritesAlignData.data"
        @click="spritesAlignFS(item.type)"
        :class="{
          separationline: item.type == 'none'
        }"
      >
        <i
          v-if="item.type != 'none'"
          :class="item.class"
          :style="{
            transform : 'rotate(' + item.rotate + ')',
          }"
        ></i>
        <span v-if="item.type != 'none'" >{{item.name}}</span>
      </div>
    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import popupSecond from '../../mixins/popupSecond'
import Analysis from '../../mixins/analysis/materialBu'
import draggable from '@/plugins/vuedraggable'
import dragFn from '@/components/mixins/forDragFn'

export default {
  mixins: [popupSecond, Analysis, dragFn],
  data() {
    return {
      spritesData : [],
      boxDataName : 'sprites',   // 弹窗名称
      dragAreaName: '图层设置',
      judgedrag   : true,
      spritesIndex  : {          // 元素的index
        judgeMove : false,
        index     : 0,
        rmIndex   : 0,
        id        : '',
      },
      actionType        : false, // 判断是什么状态下的功能显示
      layersprite       : {      // 组合元素层级数据
        top : true,
        bottom : true,
        listData : [],
      },
      spritesAlignData  : {      // 多选元素对齐
        data : [
          {
            type : 'left',
            name : '左对齐',
            class: 'icon-align-left',
            rotate : '0deg',
          },
          {
            type : 'level-center',
            name : '水平居中',
            class: 'icon-align-center',
            rotate : '90deg',
          },
          {
            type : 'right',
            name : '右对齐',
            class: 'icon-align-right',
            rotate : '0deg',
          },
          {
            type : 'none',
          },
          {
            type : 'top',
            name : '顶对齐',
            class: 'icon-align-left',
            rotate : '90deg',
          },
          {
            type : 'vertical-center',
            name : '垂直居中',
            class: 'icon-align-center',
            rotate : '0deg',
          },
          {
            type : 'bottom',
            name : '底对齐',
            class: 'icon-align-right',
            rotate : '90deg',
          },
          {
            type : 'none',
          },
          {
            type : 'level-equal',
            name : '水平等间距',
            class: 'icon-align-center-center',
            rotate : '0deg',
          },
          {
            type : 'vertical-equal',
            name : '垂直等间距',
            class: 'icon-align-center-center',
            rotate : '90deg',
          },
        ],
        boxPos : [],
        dataPos: [],
        levelEqual    : 0,
        verticalEqual : 0,
      },
      undoRedoData : {
        oldVal: [],
        val: [],
        scale: '',
        scenesId: '',
      }
    };
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg',
    ]),
    dragOptions () {
      return  {
        disabled          : this.judgedrag,  // 控制开关
        scroll            : true,            // 开启滚动
        scrollSensitivity : 150,             // 滚动区域
        animation         : 100,
        group             : {
          put: false,                        // 单组拖拽
          name: "spritesDrag",
        },
        rmgroup           : '',              // 保存的删除分组
      };
    },
  },
  watch : {
    'boxDatas.secondData' : function(val, oldval){ // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.secondData, 'sprites');
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if(this.TOOL && this.boxData.judgeBox){ // 打开的操作
        this.boxData.Zindex   = (this.dataMsg.length + 1 )*5;
        this.boxData.data     = this.dataMsg.sprites;
        this.boxData.fix.x    = this.dataMsg.sprites.posx+2;
        this.boxData.fix.y    = this.dataMsg.sprites.posy+2;

        this.actionType = this.dataMsg.sprites.actionType || 'layer';
        switch(this.actionType){
          case 'layerSetting':
            this.dragAreaName = '图层'
            this.boxData.fix.x = this.boxData.fix.x - 20;
            this.judgeLayersprite();
            break;
          case 'layer':
            this.dragAreaName = '图层设置'
            this.actionType = 'layer';
            let dataArray   = this.SelectScenes_Msg.getSprites({height: 44, width: 78}); // 高度
            this.arrayStore(dataArray);
            this.$bus.emit('showTips', { // 弹出气泡提示
              text: '可拖动相应的元素，以调节其在画布中的图层顺序。',
              position: {
                top: '100px',
                right: '90px'
              }
            });
            break;
          case 'spritesAlign':
            this.dragAreaName = '素材排版'
            this.boxData.fix.x = this.boxData.fix.x + 136;
            this.spritesAlignLoad();
            break;
        }
      }
    },
    'SelectScenes_Msg.sprites': function(val, oldval){
      if(this.TOOL && this.SelectScenes_Msg && this.boxData.judgeBox){
        let dataArray = this.SelectScenes_Msg.getSprites({height: 44, width: 78});
        this.arrayStore(dataArray);
      }
    },
  },
  props: [],
  mounted () {
    this.$bus.on('spriteAdded_vue',(data) => {  // 元素添加
      if(this.TOOL && this.SelectScenes_Msg && this.boxData.judgeBox){
        let dataArray = this.SelectScenes_Msg.getSprites({height: 44, width: 78});
        this.arrayStore(dataArray);
      }
    });
    this.$bus.on('updateSprite_vue',(data) => {  // 元素修改
      if(this.TOOL && this.SelectScenes_Msg && this.boxData.judgeBox){
        let dataArray = this.SelectScenes_Msg.getSprites({height: 44, width: 78});
        this.arrayStore(dataArray);
      }
    });
    document.onmousedown = (event) => {
      this.close();
    };
    eve.on('SelectSprites_process', ({moveData, pos, old}) => {
      // 多选元素’按比例放大旋转‘操作函数
      let deg = 0,
          scaleSize = 1,
          css = moveData.css,
          change = null,
          sprite = null,
          oldBox = null;
      css.cx = css.left + css.width / 2;
      css.cy = css.top + css.height / 2;
      if(moveData.action === 'spin') {
        deg = this._angle(pos.x, pos.y, moveData.x, moveData.y, css.cx, css.cy);
        change = {rotate: deg}
      } else {
        scaleSize = this._scaleSize(pos.x, pos.y, moveData.x, moveData.y, css.cx, css.cy)
        if( (scaleSize*css.width) < 50 || (scaleSize*css.height) < 50  ){
          scaleSize = 50 / css.width > 50 / css.height ? 50 / css.height : 50 / css.width;
        }
        change = {
          width: css.width * scaleSize,
          height: css.height * scaleSize,
          top: css.top,
          left: css.left,
          rotate: 0
        }
        if(moveData.action === 'ne') {
          change.top = css.top + (css.height * (1 - scaleSize));
        } else if(moveData.action === 'nw') {
          change.top = css.top + (css.height * (1 - scaleSize));
          change.left = css.left + (css.width * (1 - scaleSize));
        } else if(moveData.action === 'sw') {
          change.left = css.left + (css.width * (1 - scaleSize));
        }
      }
      this.TOOL.updateMultiSelect(true, change)

      for(let i = 0; i < this.SelectSprites_Msg.length; i++){
        sprite = this.SelectSprites_Msg[i];
        if(sprite.id === old[i].id) {
          oldBox = old[i];
        } else {
          oldBox = old.find(v => v.id === id);
        }

        if(moveData.action === 'spin'){  // 旋转计算
          let spritePos = sprite._rotateWithPoint({
              x : css.cx,
              y : css.cy,
            },
            deg,
            {
              x : oldBox.positionLeft,
              y : oldBox.positionTop,
              rotate : oldBox.rotate,
            },
          );
          sprite.rotate = spritePos.rotate;
          sprite.positionTop = spritePos.top;
          sprite.positionLeft = spritePos.left;
          sprite.changeStyle();
        }else{  // 按比例缩放计算
          let newPos = {
            x: (oldBox.positionLeft - css.left) * scaleSize,
            y: (oldBox.positionTop - css.top) * scaleSize
          }
          sprite.width  = oldBox.width * scaleSize;
          sprite.height = oldBox.height * scaleSize;
          sprite.positionLeft = change.left + newPos.x;
          sprite.positionTop  = change.top + newPos.y;
          if(sprite.type == "Text"){
            sprite.font.fontSize =  parseInt(oldBox.fontSize * scaleSize);
            if(sprite.font.fontSize < 6){
              sprite.font.fontSize = 6;
            }
          } else if(sprite.type === 'RichText') {
            sprite.width = oldBox.width;
            sprite.height = oldBox.height;
          }
          sprite.changeStyle();
        }
        
      }
    });
    eve.on('SelectSprites_process_up', (data) => {  // 多选元素’按比例放大旋转‘操作完成后的函数
      if(this.TOOL){
        if(data.action == "spin"){
            this.materialPushAnalysisTwo('process-spin');
        }else{
            if(data.action.indexOf('move') < 0){
              this.materialPushAnalysisTwo('process-zoom');
            }
        }

        for(let i = 0; i < this.SelectSprites_Msg.length; i++){
          let sprite = this.SelectSprites_Msg[i];
          if(sprite.type == "Text"){
            this.TOOL.updateSprite(sprite.id, {
              font: {
                fontSize: Math.floor(sprite.font.fontSize)
              }
            }, sprite.scenesId);
          }
        }
      }
    });
  },
  methods: {
    judgedragFs(data){
      this.judgedrag = data;
    },
    moveSprites(data, id){
      if(data){
        this.TOOL.moveSpriteTo(id, this.SelectScenes_Msg.sprites.length, true)
      }else{
        this.TOOL.moveSpriteTo(id, 0, true)
      }
      this.selectSprite(id);
    },
    onMove(evt){
      if(evt){
        let index = 0;
        let id = evt.dragged.attributes['data-id'].value;
        if(!this.spritesIndex.judgeMove){
          this.spritesIndex.index = parseInt(evt.dragged.dataset.index);
          this.spritesIndex.id = evt.dragged.attributes['data-id'].value;
          this.spritesIndex.rmIndex = (evt.draggedContext.index - evt.relatedContext.index);
          index =  evt.relatedContext.element.index;
        }else{
          index =  evt.relatedContext.element.index;
          this.spritesIndex.rmIndex = this.spritesIndex.rmIndex - evt.relatedContext.index;
        }
        this.spritesIndex.judgeMove = true;
        this.spritesIndex.index = index;
      }
    },
    onEnd(evt){
      if(evt){
        this.TOOL.moveSpriteTo(this.spritesIndex.id, this.spritesIndex.index, true)
        this.spritesIndex.judgeMove = false;
        this.selectSprite(this.spritesIndex.id);
      }
    },
    spritesTit(data){
      let title = '图片';
      switch(data){
        case 'Image':
        case 'Svg':
          title =  '图片';
          break;
        case 'Text':
          title =  '文字';
          break;
        case 'Lottie':
          title =  '动画素材';
          break;
      }
      return title;
    },
    stopDocument(e){ // 防止事件冒泡
      e.stopPropagation();
    },
    arrayStore(data){
      this.spritesData  = [];
      for(let i = data.length; i >= 0; i--){
        if(data[i]){
          this.spritesData.push(data[i])
        }
      }
    },
    layerSettingFS(action){
      let len = this.layersprite.listData.length - 1;

      for (let j = 0; j < len; j++) {
        for (let i = 0; i < len - j; i++) {
          if (this.layersprite.listData[i].index > this.layersprite.listData[i + 1].index) {
            [this.layersprite.listData[i], this.layersprite.listData[i + 1]] = [this.layersprite.listData[i + 1], this.layersprite.listData[i]]
          }
        }
      }

      switch(action){
        case 'top':

          for(let i = 0; i < this.layersprite.listData.length; i++){
            this.layersprite.listData[i].index = i;
          }
          break;
        case 'bottom':

          this.layersprite.listData.reverse();
          for(let i = 0; i < this.layersprite.listData.length; i++){
            this.layersprite.listData[i].index = this.SelectScenes_Msg.sprites.length -1 - i;
          }
          break;
        case 'pre':

          if(!this.layersprite.bottom){
            return;
          }
          for(let i = 0; i < this.layersprite.listData.length; i++){
            this.layersprite.listData[i].index = this.layersprite.listData[i].index - 1;
          }
          break;
        case 'next':

          if(!this.layersprite.top){
            return;
          }
          this.layersprite.listData.reverse();
          for(let i = 0; i < this.layersprite.listData.length; i++){
            this.layersprite.listData[i].index = this.layersprite.listData[i].index + 1;
          }
          break;
      }
      for(let i = 0; i < this.layersprite.listData.length; i++){

        let sprite = this.layersprite.listData[i];
        this.TOOL.moveSpriteTo(sprite.id, sprite.index, true);
      }
      this.judgeLayersprite();
      this.materialPushAnalysisTwo('layerSettingFS'+action);
    },
    judgeLayersprite(){ // 判断上移下移
      this.layersprite.listData = [];
      let top    = this.SelectSprites_Msg[0].index,
          bottom = this.SelectSprites_Msg[0].index;

      for(let i = 0; i < this.SelectSprites_Msg.length; i++){

        top = top > this.SelectSprites_Msg[i].index ? top : this.SelectSprites_Msg[i].index;
        bottom = bottom < this.SelectSprites_Msg[i].index ? bottom : this.SelectSprites_Msg[i].index;
        this.layersprite.listData.push({
          id : this.SelectSprites_Msg[i].id,
          index : this.SelectSprites_Msg[i].index,
        });
      }
      this.layersprite.top    = top >= (this.SelectScenes_Msg.sprites.length - 1) ? false : true;
      this.layersprite.bottom = bottom <= 0 ? false : true;
    },
    spritesAlignLoad(){ // 元素多选对齐数据收集
      this.spritesAlignData.boxPos  = {};
      this.spritesAlignData.dataPos = [];
      this.spritesAlignData.dataPos.levelEqual = 0;

      this.spritesAlignData.boxPos.left = this.TOOL.multiSelect.css.left;
      this.spritesAlignData.boxPos.top = this.TOOL.multiSelect.css.top;
      this.spritesAlignData.boxPos.width = this.TOOL.multiSelect.css.width;
      this.spritesAlignData.boxPos.height = this.TOOL.multiSelect.css.height;

      let levelEqual = 0, verticalEqual = 0;

      for(let i = 0; i < this.SelectSprites_Msg.length; i++){
        let sprite = this.SelectSprites_Msg[i],
            posData= {
              x  : 0,
              y  : 0,
              id : sprite.id,
              width  : 0,
              height : 0,
            };
        if(sprite.rotate != 0){

          let maxData = this.spriteRotate(sprite);
          posData.y = maxData.max_Y[0];
          posData.x = maxData.max_X[0];
          posData.height = maxData.max_Y[3] - posData.y;
          posData.width  = maxData.max_X[3] - posData.x;
        }else{

          posData.x = sprite.positionLeft;
          posData.y = sprite.positionTop;
          posData.height = sprite.height;
          posData.width  = sprite.width;
        }
        levelEqual += posData.width;
        verticalEqual += posData.height;
        this.spritesAlignData.dataPos.push(posData);
      }

      let len = this.spritesAlignData.dataPos.length - 1;
      for (let j = 0; j < len; j++) {
        for (let i = 0; i < len - j; i++) {

            if (this.spritesAlignData.dataPos[i].x > this.spritesAlignData.dataPos[i + 1].x) {
              [this.spritesAlignData.dataPos[i], this.spritesAlignData.dataPos[i + 1]] = [this.spritesAlignData.dataPos[i + 1], this.spritesAlignData.dataPos[i]]
            }
        }
      }
      this.spritesAlignData.levelEqual    = (this.spritesAlignData.boxPos.width - levelEqual) /  (this.spritesAlignData.dataPos.length - 1);
      this.spritesAlignData.verticalEqual = (this.spritesAlignData.boxPos.height - verticalEqual) /  (this.spritesAlignData.dataPos.length - 1);
    },
    spritesAlignFS(type){ // 对齐控制函数
      if(type == 'none')return;
      this.undoFS();
      this.TOOL.multiSelect.action = true;
      if(type == 'vertical-equal'){
        let len = this.spritesAlignData.dataPos.length - 1;
        for (let j = 0; j < len; j++) {
          for (let i = 0; i < len - j; i++) {

              if (this.spritesAlignData.dataPos[i].y > this.spritesAlignData.dataPos[i + 1].y) {
                [this.spritesAlignData.dataPos[i], this.spritesAlignData.dataPos[i + 1]] = [this.spritesAlignData.dataPos[i + 1], this.spritesAlignData.dataPos[i]]
              }
          }
        }

      }
      let levelEqual_verticalEqual = 0;
      for (let j = 0; j < this.spritesAlignData.dataPos.length; j++) {

        let spriteData = this.spritesAlignData.dataPos[j],
            sprite;

        sprite = this.TOOL.findSpriteById(spriteData.id);
        let maxData = this.spriteRotate(sprite), allAction = true;

        switch(type){
          case 'left':   // 左对齐

            if(sprite.rotate != 0){

              spriteData.x =  sprite.positionLeft - (maxData.max_X[0] - this.spritesAlignData.boxPos.left);
            }else{

              spriteData.x =  this.spritesAlignData.boxPos.left;
            }
            spriteData.y = sprite.positionTop;
            break;
          case 'level-center': // 水平居中

            let levelCenter = this.spritesAlignData.boxPos.left + (this.spritesAlignData.boxPos.width / 2);

            if(sprite.rotate != 0){

              levelCenter = levelCenter - (maxData.max_X[0] + (spriteData.width / 2) );
              spriteData.x =  sprite.positionLeft + levelCenter;
            }else{

              spriteData.x =  levelCenter - (spriteData.width / 2);
            }
            spriteData.y = sprite.positionTop;
            break;
          case 'right':  // 右对齐

            let rightData = this.spritesAlignData.boxPos.left + this.spritesAlignData.boxPos.width;
            if(sprite.rotate != 0){

              spriteData.x =  sprite.positionLeft - (maxData.max_X[3] - rightData);
            }else{

              spriteData.x =  rightData - spriteData.width;
            }
            spriteData.y = sprite.positionTop;
            break;
          case 'top':    // 顶对齐

            let topData = this.spritesAlignData.boxPos.top;
            if(sprite.rotate != 0){

              spriteData.y =  sprite.positionTop - (maxData.max_Y[0] - topData);
            }else{

              spriteData.y =  topData;
            }
            spriteData.x = sprite.positionLeft;
            break;
          case 'vertical-center':    // 垂直居中

            let verticalCenter = this.spritesAlignData.boxPos.top + (this.spritesAlignData.boxPos.height / 2);
            if(sprite.rotate != 0){

              verticalCenter = verticalCenter - (maxData.max_Y[0] + (spriteData.height / 2) );
              spriteData.y   =   sprite.positionTop + verticalCenter;
            }else{

              spriteData.y =  verticalCenter - (spriteData.height / 2);
            }
            spriteData.x = sprite.positionLeft;
            break;
          case 'bottom':  // 底对齐

            let bottomData = this.spritesAlignData.boxPos.top + this.spritesAlignData.boxPos.height;
            if(sprite.rotate != 0){

              spriteData.y =  sprite.positionTop - (maxData.max_Y[3] - bottomData);
            }else{

              spriteData.y =  bottomData - spriteData.height;
            }
            spriteData.x = sprite.positionLeft;
            break;
          case 'level-equal':   // 水平等间距
            if(this.spritesAlignData.dataPos.length == 2){
              allAction = false;
              break;
            }

            let allMaxWdith = (this.spritesAlignData.boxPos.left + this.spritesAlignData.boxPos.width);
            if(sprite.rotate != 0){

              let levelEqual = 0;
              if(j ==  0 ){

                levelEqual   = (maxData.max_X[0] - this.spritesAlignData.boxPos.left);
                spriteData.x =  sprite.positionLeft - levelEqual;
              }else{

                if(j == (this.spritesAlignData.dataPos.length-1)){

                  levelEqual   = sprite.positionLeft - (maxData.max_X[3] - levelEqual_verticalEqual);
                  spriteData.x = levelEqual;
                }else{

                  levelEqual   = (this.spritesAlignData.boxPos.left + levelEqual_verticalEqual) - maxData.max_X[0];
                  spriteData.x =  sprite.positionLeft + levelEqual;
                }

              }
            }else{
              if(j ==  0 ){

                spriteData.x =  (this.spritesAlignData.boxPos.left + levelEqual_verticalEqual);
              }else{

                if(j == (this.spritesAlignData.dataPos.length-1)){

                  spriteData.x =  (levelEqual_verticalEqual - spriteData.width);
                }else{

                  spriteData.x =  (this.spritesAlignData.boxPos.left + levelEqual_verticalEqual);
                }
              }
              let maxWidth = spriteData.x + spriteData.width;
              if(maxWidth > (this.spritesAlignData.boxPos.left + this.spritesAlignData.boxPos.width)){
                spriteData.x = spriteData.x  - (maxWidth - allMaxWdith);
              }
            }
            if(j <= (this.spritesAlignData.dataPos.length - 3)){

              let thisWidth = (spriteData.width + this.spritesAlignData.levelEqual);
              thisWidth = thisWidth.toFixed(2) - 0;
              levelEqual_verticalEqual += thisWidth;
            }else{

              levelEqual_verticalEqual = this.spritesAlignData.boxPos.left + this.spritesAlignData.boxPos.width;
            }
            spriteData.y = sprite.positionTop;
            break;
          case 'vertical-equal':   // 垂直等间距（水平、垂直等间距计算第一次之后有素材最小点排列层级发生变化，会再进行第二次计算）
            if(this.spritesAlignData.dataPos.length == 2){
              allAction = false;
              break;
            }

            let allMaxHeight = (this.spritesAlignData.boxPos.top + this.spritesAlignData.boxPos.height);
            if(sprite.rotate != 0){

              let verticalEqual = 0;
              if(j ==  0 ){

                verticalEqual   = (maxData.max_Y[0] - this.spritesAlignData.boxPos.top);
                spriteData.y =  sprite.positionTop - verticalEqual;
              }else{

                if(j == (this.spritesAlignData.dataPos.length-1)){

                  verticalEqual   = sprite.positionTop - (maxData.max_Y[3] - levelEqual_verticalEqual);
                  spriteData.y = verticalEqual;
                }else{

                  verticalEqual   = maxData.max_Y[0] -  (this.spritesAlignData.boxPos.top + levelEqual_verticalEqual);

                  if((maxData.max_Y[3] + verticalEqual) > allMaxHeight){

                    spriteData.y =  sprite.positionTop - verticalEqual - ((maxData.max_Y[3] + verticalEqual) - allMaxHeight);
                  }else{

                    spriteData.y =  sprite.positionTop - verticalEqual;
                  }
                }

              }
            }else{
              let maxHeight = spriteData.y + spriteData.height;
              if(j ==  0 ){

                spriteData.y =  (this.spritesAlignData.boxPos.top + levelEqual_verticalEqual);
              }else{

                if(j == (this.spritesAlignData.dataPos.length-1)){

                  spriteData.y =  (levelEqual_verticalEqual - spriteData.height);
                }else{

                  spriteData.y =  (this.spritesAlignData.boxPos.top + levelEqual_verticalEqual);
                }
              }
              if(maxHeight > allMaxHeight){
                spriteData.y = spriteData.y  - (maxHeight - allMaxHeight);
              }
            }

            if(j <= (this.spritesAlignData.dataPos.length - 3)){

              let thisHeight = (spriteData.height + this.spritesAlignData.verticalEqual);
              thisHeight = thisHeight.toFixed(2) - 0;
              levelEqual_verticalEqual += thisHeight;
            }else{

              levelEqual_verticalEqual = allMaxHeight;
            }
            spriteData.x = sprite.positionLeft;
            break;
        }
        if(allAction){
          spriteData.x.toFixed(2) - 0;
          spriteData.y.toFixed(2) - 0;
          sprite.positionLeft = spriteData.x;
          sprite.positionTop  = spriteData.y;
          sprite.changeStyle();
        }
      }

      this.TOOL.calcMultiSelect('rePaint');
      let timeoutid = setTimeout(() => {
        this.TOOL.multiSelect.action = false;
        this.spritesAlignLoad();
        this.materialPushAnalysisTwo('spritesAlignFS' + type);
        this.RedoFS();
        clearTimeout(timeoutid);
      }, 100);
    },
    Rotate(action, data, o){ // Angle为正时逆时针转动, 单位为弧度
        data = Math.PI/180 * data;
        var b = {};
        b.x = ( action.x - o.x ) * Math.cos(data) - ( action.y - o.y ) * Math.sin(data) + o.x;
        b.y = ( action.x - o.x ) * Math.sin(data) + ( action.y - o.y ) * Math.cos(data) + o.y;

        return b;
    },
    spriteRotate(sprite){
      var max_X = new Array(4),
          max_Y = new Array(4),
          top, left, bottom, right;

      top    = this.Rotate(
          {
              x : sprite.positionLeft ,
              y : sprite.positionTop
          },
          sprite.rotate,
          {
              x: sprite.positionLeft + (sprite.width/2),
              y: sprite.positionTop + (sprite.height/2)
          }
      );
      max_X.push(top.x);
      max_Y.push(top.y);

      left   = this.Rotate(
          {
              x : sprite.positionLeft + sprite.width ,
              y : sprite.positionTop
          },
          sprite.rotate,
          {
              x: sprite.positionLeft + (sprite.width/2),
              y: sprite.positionTop + (sprite.height/2)
          }
      );
      max_X.push(left.x);
      max_Y.push(left.y);

      bottom = this.Rotate(
          {
              x : sprite.positionLeft + sprite.width,
              y : sprite.positionTop + sprite.height
          },
          sprite.rotate,
          {
              x: sprite.positionLeft + (sprite.width/2),
              y: sprite.positionTop + (sprite.height/2)
          }
      );
      max_X.push(bottom.x);
      max_Y.push(bottom.y);

      right  = this.Rotate(
          {
              x : sprite.positionLeft ,
              y : sprite.positionTop + sprite.height
          },
          sprite.rotate,
          {
              x: sprite.positionLeft + (sprite.width/2),
              y: sprite.positionTop + (sprite.height/2)
          }
      );
      max_X.push(right.x);
      max_Y.push(right.y);

      max_X = max_X.sort(function(a, b){
          return a - b;
      });
      max_Y = max_Y.sort(function(a, b){
          return a - b;
      });
      return {
        max_X,
        max_Y
      }
    },
    undoFS() {
      if(this.SelectSprites_Msg.length === 0) return;

      this.undoRedoData.oldVal   = [];
      this.undoRedoData.val      = [];
      this.undoRedoData.scale    = this.TOOL.scale,
      this.undoRedoData.scenesId = this.SelectScenes_Msg.id

      this.SelectSprites_Msg.forEach((s) => {

        let oldM = {
          id     : s.id,
          width  : s.width,
          height : s.height,
          rotate : s.rotate,
          positionTop  : s.positionTop,
          positionLeft : s.positionLeft,
        };

        this.undoRedoData.oldVal.push(oldM)
      })
    },
    RedoFS() {
      if(this.SelectSprites_Msg.length === 0 && !this.undoRedoData.oldVal.length) return;

      this.undoRedoData.val = [];
      this.SelectSprites_Msg.forEach((s) => {

        let newM = {
          id     : s.id,
          width  : s.width,
          height : s.height,
          rotate : s.rotate,
          positionTop  : s.positionTop,
          positionLeft : s.positionLeft,
        };

        this.undoRedoData.val.push(newM)
      })
      eve("undo_redo", null, {type: 'matrix', data: this.undoRedoData})
    },
    selectSprite (id) {
      let sprite = this.TOOL.getSpriteIdData(id);
      this.TOOL.selectSprite([sprite]);
    }
  },
  components: {
    draggable,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .SpritesC{
    position: fixed;
    top: 0;
    left: 0;
    width: 300px;
    height: 650px;
    z-index: 35;
    box-shadow: #d8dee9 0px 0px 5px 0px;
    border-radius: 6px 6px 3px 3px;
    border: 1px solid #d8dee9;
    background: #fff;
    overflow: hidden;

    .dragArea{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px 0 15px;
      height: 28px;
      background-color: #d8dee9;
      span {
        width: 80px;
        text-align: left;
        color: #474261;
      }
      i {
        display: inline-block;
        width: 12px;
        height: 12px;
        cursor: pointer;
      }
    }

    .spriteBoody{
      height: 620px;
      width: 315px;
      overflow-y: auto;

      .sprite{
        position: relative;
        width: 300px;
        height: 78px;
        background: transparent;
        transition: all 0.3s;
        cursor: grab;

        &:hover{
          background: #EFF1F8;

          .spritestit{
            .spriteBtn{
              opacity: 1;
            }
          }
        }
        .thumbnails{
          position: absolute;
          top: 0px;
          bottom: 0;
          left: 25px;
          margin: auto 0;
          width: 78px;
          height: 44px;
          // overflow: hidden;
          cursor: pointer;

          &:hover {
            &::before {
              background-color: rgba(#5778fb, 0.2);
            }
          }

          &::before {
            content: ' ';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            width: 100%;
            height: 60px;
            z-index: 100;
            border-radius: 4px;
          }
        }
        .spritestit{
          position: absolute;
          top: 0px;
          left: 138px;
          width: 160px;
          height: 76px;
          cursor: auto;

          .spriteBtn{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #EFF1F8;
            opacity: 0;
            transition: all 0.2s;

            span{
              width: 30px;
              height: 30px;
              position: relative;
            }
            .icon-layer-top-big{
              &:before{
                content: '\7F6E\9876';
                position: absolute;
                bottom: -18px;
                left: 0;
                width: 30px;
                font-size: 13px;
              }
            }
            .icon-layer-bottom-big{
              &:before{
                content: '置底';
                position: absolute;
                bottom: -18px;
                left: 0;
                width: 30px;
                font-size: 13px;
              }
            }
          }

          >span{
            position: absolute;
            top: 0px;
            left: 0px;
            bottom: 0px;
            right: 0px;
            width: 60px;
            height: 20px;
            line-height: 20px;
            text-align: left;
            margin: auto;
          }
        }
      }
    }

    .spriteBoody_layerSetting{
      height: 100px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      >div{
        width: 60px;
        height: 60px;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #474261;
        border-radius: 5px;
      }
      .icon-editor-btn-layer-top{
        width: 21px;
        height: 21px;
        background: url('../../../../static/svg/stick-top.svg') no-repeat center;
        background-size: 21px;
      }
      .icon-editor-btn-layer-bottom{
        width: 21px;
        height: 21px;
        background: url('../../../../static/svg/stick-bottom.svg') no-repeat center;
        background-size: 21px;
      }
      .icon-editor-btn-layer-up{
        width: 21px;
        height: 21px;
        background: url('../../../../static/svg/layer-setting-up-active.svg') no-repeat center;
        background-size: 21px;
      }
      .icon-editor-btn-layer-down{
        width: 21px;
        height: 21px;
        background: url('../../../../static/svg/layer-setting-down.svg') no-repeat center;
        background-size: 20px;
      }
      .layerDisable{
        color: #e7e6eb;
        cursor: not-allowed;
        .icon-editor-btn-layer-up{
          width: 21px;
          height: 21px;
          background: url('../../../../static/svg/layer-setting-up.svg') no-repeat center;
          background-size: 21px;
        }
        .icon-editor-btn-layer-down{
          width: 21px;
          height: 21px;
          background: url('../../../../static/svg/layer-setting-down-active.svg') no-repeat center;
          background-size: 20px;
        }
      }
    }

    .spriteBoody_spritesAlign{

      >div{
        display: flex;
        align-items: center;
        padding-left: 27px;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #474261;
        margin: 20px 0;
        cursor: pointer;

        >i{
          width: 16px;
          height: 16px;
          margin-right: 18px;
        }
        .icon-align-left {
          background: url('../../../../static/svg/align-left.svg') no-repeat center;
        }
        .icon-align-right {
          background: url('../../../../static/svg/align-right.svg') no-repeat center;
        }
        .icon-align-center {
          background: url('../../../../static/svg/align-center.svg') no-repeat center;
        }
        .icon-align-center-center{
          background: url('../../../../static/svg/align-center-center-active.svg') no-repeat center;
          background-size: 89%;
        }

        &:hover{
          color: #5778fb;
          .icon-align-center{
            background: url('../../../../static/svg/align-center-active.svg') no-repeat center;
          }
          .icon-align-right {
            background: url('../../../../static/svg/align-right-active.svg') no-repeat center;
          }
          .icon-align-left {
            background: url('../../../../static/svg/align-left-active.svg') no-repeat center;
          }
          .icon-align-center-center{
            background: url('../../../../static/svg/align-center-center.svg') no-repeat center;
            background-size: 89%;
          }
        }
      }
      .separationline{
        width: 128px;
        height: 1px;
        background-color: #f0f0f8;
      	border-radius: 1px;
        margin: 0 auto;
      }
    }
  }
  .spritesAlignBox{
    width: 164px;
  	height: 410px;
    box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
  	border-radius: 8px;
  }
  .layerSettingBox{
    width: 320px;
    height: 128px;
    box-shadow: 0px 0px 4px 0px
      rgba(54, 76, 204, 0.4);
    border-radius: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/popups/secondPopups/spritesClick.vue